import { Component, ElementRef, Input, OnChanges, OnInit, ViewChild } from '@angular/core'
import { DxDataGridComponent } from 'devextreme-angular';
import { Workbook } from 'exceljs';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { saveAs } from 'file-saver';
import { SuspectsWithContactNames } from '../types/SuspectsWithContactNames';

@Component({
  selector: 'suspects-with-contact-names',
  templateUrl: './suspects-with-contact-names.component.html'
})
export class SuspectsWithContactNamesComponent {
  @ViewChild('suspectsWithContactNamesGrid', { static: true }) suspectsWithContactNamesGrid: DxDataGridComponent;
  _suspectsWithContactNames: SuspectsWithContactNames[];
  
  @Input()
  set suspectsWithContactNames(value: SuspectsWithContactNames[]) { 
    this._suspectsWithContactNames = value;
  }

  get suspectsWithContactNames(): SuspectsWithContactNames[] {
    return this._suspectsWithContactNames;
  }

  chooserMode: string = 'select';
  header1: string = 'Companies with Contact Names. Data may not be current. Only companies with contacts are listed.';

  constructor() {

  }

  exportExcel(e) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('SuspectsWithContactNames');
    exportDataGrid({
      component: this.suspectsWithContactNamesGrid.instance,
      worksheet: worksheet
    }).then(function () {
      workbook.xlsx.writeBuffer()
        .then(function (buffer: BlobPart) {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'SuspectsWithContactNames.xlsx');
        });
    });
    e.cancel = true;
  }


}

